import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { SharedUser } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<SharedUser>>>;

const getSharedUsersOnOrganization = (id: string): ReturnType => {
    return Request.get(`/organizations/${id}/users`);
};

export default getSharedUsersOnOrganization;
